export enum DataExchangeSubRequestTypeDto {
  PackagingUnit = 0,
  PackagingSystem = 1,
  PackagingComponent = 2,
  MultiMaterial = 3
}
